import "./Navbar.css";

function Navbar() {
  return (
    <nav className="navbar">
      <div className="left">
        <a href="#home">MOSSROCK</a>
      </div>
      <div className="right">
        <ul>
          <li>
            <a href="#acs">IEC 62443 Consultancy</a>
          </li>
          <li>
            <a href="#security">Cyber Security Consultancy</a>
          </li>
          <li>
            <a href="#it">IT Consultancy</a>
          </li>
          <li>
            <a href="#tutoring">Tutoring</a>
          </li>
          <li>
            <a href="#contact">Contact</a>
          </li>
        </ul>
      </div>
    </nav>
  );
}

export default Navbar;
